import React, { useState, useEffect, useRef } from "react";
import { Grid, InputLabel, makeStyles } from "@material-ui/core";
import { InputField, SelectField } from "../FormFields";
import { GetCookies } from "../../../../_helpers/Cookies";
import { validateInput } from "../../../../_helpers/validationHelper";
import getSymbolFromCurrency from "currency-symbol-map";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";

const useStyles = makeStyles((theme) => ({
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "4px !important",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            borderRadius: "4px",
            height: "0px",
        },
    },
}));

export default function MarkupCurrency(props) {
    const { features } = useSelector((state) => state.plan);

    const classes = useStyles();

    const {
        formField: { muti_currency, tax_value, tax_name },
        setFieldValue,
        values,
    } = props;

    const taxSectionRef = useRef(null);

    useEffect(() => {
        if (values.taxinclusive && taxSectionRef.current) {
            taxSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [values.taxinclusive]);

    const [currencyDropdown, setCurrencyDropdown] = useState([]);

    useEffect(() => {
        let isMounted = true; // ← track mounting status

        async function fetchConversionRates() {
            try {
                const response = await GetCookies("conversionrates");
                if (!isMounted) return; // ← bail out if unmounted

                // only proceed if you got a non‐empty cookie
                if (response && response[0]) {
                    const currencies = JSON.parse(response)[0];

                    const options = Object.entries(currencies)
                        .filter(
                            ([key]) =>
                                key.startsWith("cur_") && !key.includes("org")
                        )
                        .map(([key, rate]) => {
                            const code = key.split("_")[1].toUpperCase();
                            const symbol = getSymbolFromCurrency(code);
                            return {
                                value: code,
                                label: `${code} ${symbol} - ${(
                                    Math.round(rate * 100) / 100
                                ).toFixed(2)}`,
                            };
                        });

                    setCurrencyDropdown(options);
                }
            } catch (err) {
                console.error("Failed to load conversion rates:", err);
            }
        }

        fetchConversionRates();

        return () => {
            // cleanup: mark as unmounted so any in-flight promise won’t call setState
            isMounted = false;
        };
    }, []);
    const SetTaxInclusive = (values) => {
        props.setFieldValue("taxinclusive", !values.taxinclusive);
    };

    const handleInputChange = (name, value) => {
        if (validateInput(value)) {
            props.setFieldValue(name, value);
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} className="mt-6">
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start"
                    justify="space-between"
                >
                    <Grid item xs={8} md={4}>
                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                            Show Display Price
                            <span className="small d-block mt-2 line-height-lg">
                                Toggle to show or hide product prices.
                            </span>
                        </InputLabel>
                    </Grid>
                    <Grid item>
                        <label className="switch">
                            <input
                                type="checkbox"
                                className="success"
                                checked={!values?.hidePrice}
                                value={values?.hidePrice}
                                onChange={() => {
                                    props.setFieldValue(
                                        "hidePrice",
                                        !values.hidePrice
                                    );
                                    setFieldValue(
                                        "hidePrice",
                                        !values.hidePrice
                                    );
                                }}
                            />
                            <span className="slider" />
                        </label>
                    </Grid>
                </Grid>
            </Grid>
            {!values.hidePrice && (
                <>
                    <hr className="w-100" />
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={8} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Enable Buy / Buy Request
                                    <span className="small d-block mt-2 line-height-lg">
                                        Toggle this setting ON to enable the button. You can select which option to display in the User Permissions section.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        className="success"
                                        checked={values?.displaybuybtn}
                                        value={values?.displaybuybtn}
                                        onChange={() => {
                                            props.setFieldValue(
                                                "displaybuybtn",
                                                !values.displaybuybtn
                                            );
                                            setFieldValue(
                                                "displaybuybtn",
                                                !values.displaybuybtn
                                            );
                                        }}
                                    />
                                    <span className="slider" />
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr className="w-100" />
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={8} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Cart Notifications
                                    <span className="small d-block mt-2 line-height-lg">
                                        Enable notifications for admin, when items are added to the cart.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        className="success"
                                        checked={values?.cartNotification}
                                        value={values?.cartNotification}
                                        onChange={() => {
                                            props.setFieldValue(
                                                "cartNotification",
                                                !values.cartNotification
                                            );
                                            setFieldValue(
                                                "cartNotification",
                                                !values.cartNotification
                                            );
                                        }}
                                    />
                                    <span className="slider" />
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr className="w-100" />
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={12} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Default Currency
                                    <span className="small d-block mt-2 line-height-lg">
                                        Choose the currency that will be shown by default.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Select
                                    name={muti_currency.name}
                                    options={currencyDropdown}
                                    value={currencyDropdown.filter((option) =>
                                        values.muti_currency.includes(
                                            option.value
                                        )
                                    )}
                                    onChange={(opts) => {
                                        props.setFieldValue(
                                            muti_currency.name,
                                            opts.value
                                        );
                                        setFieldValue(
                                            muti_currency.name,
                                            opts.value
                                        );

                                        const uniqueCurrencies = [
                                            ...new Set([
                                                ...values.allowedCurrencies,
                                                opts.value,
                                            ]),
                                        ];
                                        props.setFieldValue(
                                            "allowedCurrencies",
                                            uniqueCurrencies
                                        );
                                        setFieldValue(
                                            "allowedCurrencies",
                                            uniqueCurrencies
                                        );
                                    }}
                                    placeholder="Select default currency"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={8} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Allow Currency Switching
                                    <span className="small d-block mt-2 line-height-lg">
                                        Let users switch between multiple currencies.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        className="success"
                                        checked={values?.allowCurrencyChange}
                                        value={values?.allowCurrencyChange}
                                        onChange={() => {
                                            if (
                                                features["multi_currency"]
                                                    .allowed === 0
                                            ) {
                                                toast.dismiss();
                                                toast.error(<div><b>Feature unavailable.</b> <br></br>Please contact your account manager to upgrade your plan.</div>);
                                                props.setFieldValue(
                                                    "allowCurrencyChange",
                                                    false
                                                );
                                                setFieldValue(
                                                    "allowCurrencyChange",
                                                    false
                                                );
                                                return;
                                            }
                                            props.setFieldValue(
                                                "allowCurrencyChange",
                                                !values.allowCurrencyChange
                                            );
                                            setFieldValue(
                                                "allowCurrencyChange",
                                                !values.allowCurrencyChange
                                            );
                                        }}
                                    />
                                    <span className="slider" />
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    {!values?.allowCurrencyChange ? (
                        <hr className="w-100" />
                    ) : (
                        ""
                    )}
                    {values?.allowCurrencyChange ? (
                        <>
                            <Grid item xs={12} className="my-6">
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                    justify="space-between"
                                >
                                    <Grid item xs={12} md={4}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Supported Currencies
                                            <span className="small d-block mt-2 line-height-lg">
                                                Select all currencies you want to display for your customers to switch.
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Select
                                            isMulti
                                            name="allowedCurrencies"
                                            options={currencyDropdown}
                                            value={currencyDropdown.filter(
                                                (option) =>
                                                    values.allowedCurrencies.includes(
                                                        option.value
                                                    ) || values.muti_currency.includes(option.value)
                                            )}
                                            onChange={(opts) => {
                                                const newValues = opts
                                                    ? opts.map((o) => o.value)
                                                    : [];
                                                props.setFieldValue(
                                                    "allowedCurrencies",
                                                    newValues
                                                );
                                                setFieldValue(
                                                    "allowedCurrencies",
                                                    newValues
                                                );
                                            }}
                                            placeholder="Select Currencies"
                                            closeMenuOnSelect={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <hr className="w-100" />
                        </>
                    ) : (
                        ""
                    )}
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={8} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    {/* {values.taxinclusive
                                        ? "Inclusive Tax"
                                        : "Exclusive Tax"} */}
                                        Tax Settings
                                    <span className="small d-block mt-2 line-height-lg">
                                        Choose whether tax is added as <b>inclusive</b> or <b>exclusive</b> of tax.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <label className="switch ">
                                    <input
                                        type="checkbox"
                                        className="success"
                                        checked={values.taxinclusive}
                                        value={values.taxinclusive}
                                        onClick={() => SetTaxInclusive(values)}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    {values.taxinclusive ? (
                        <>
                            <Grid
                                item
                                xs={12}
                                className="my-6"
                                ref={taxSectionRef}
                            >
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                    justify="space-between"
                                >
                                    <Grid item xs={12} md={4}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Tax Label
                                            <span className="small d-block mt-2 line-height-lg">
                                                Enter a name or label for the tax (e.g., VAT, GST).
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <InputField
                                            className={classes.textField}
                                            name={tax_name.name}
                                            fullWidth
                                            InputProps={{
                                                style: {
                                                    height: "40px",
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className="my-6">
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                    justify="space-between"
                                >
                                    <Grid item xs={12} md={4}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Tax Rate
                                            <span className="small d-block mt-2 line-height-lg">
                                                Define the applicable tax percentage.
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <InputField
                                            className={classes.textField}
                                            name={tax_value.name}
                                            fullWidth
                                            value={props.values.tax_value || ""}
                                            InputProps={{
                                                style: {
                                                    height: "40px",
                                                },
                                            }}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    e.target.name,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        ""
                    )}
                </>
            )}
        </Grid>
    );
}
